import { useEffect, useMemo, useRef, useState } from 'react';

import {
    Box,
    Button,
    Card,
    Collapse,
    Checkbox,
    Divider,
    Flex,
    Heading,
    Icon,
    Link,
    Stack,
    Text
} from '@chakra-ui/react';

import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";

import { FiExternalLink } from "react-icons/fi";

export function RegistrationForm({requestActive, eventConfig, regAllowed, regRemaining, buyBadge, recordBadge, registerOnClick}) {
    const regEndRef = useRef(null);

    const [willSpectate, setWillSpectate] = useState(false);
    const [willCompete, setWillCompete] = useState(false);
    const [spectatorFlag, setSpectatorFlag] = useState(false);

    const showPaypal = willSpectate || willCompete;

    const badgeCost = spectatorFlag === 0
        ? eventConfig["competitorPrice"]
        : eventConfig["spectatorPrice"];

    const willSpectateChecked = () => {
        setWillCompete(false);
        setWillSpectate(willSpectate ? false : true);
        setSpectatorFlag(1);
    }

    const moddingPadChecked = () => {
        setWillSpectate(false);
        setWillCompete(willCompete ? false : true);
        setSpectatorFlag(0);
    }

    useEffect(()=>{
        if (showPaypal) {
            setTimeout(()=>{
                regEndRef.current?.scrollIntoView({ behavior: 'smooth' });
            }, 400);
        }
    }, [showPaypal])

    const style = {"layout":"vertical"};

    const paypalDisplay = useMemo(()=> {
        return (
            <PayPalScriptProvider 
                options={{
                    clientId: eventConfig["payPalClientId"],
                    components: "buttons",
                    currency: "USD"
                }}
            >
                <PayPalButtons
                    style={style}
                    disabled={requestActive || !regAllowed}
                    forceReRender={[style]}
                    fundingSource={undefined}
                    createOrder={(data, actions) => buyBadge(data, actions, spectatorFlag)}
                    onApprove={(data, actions) => recordBadge(data, actions, spectatorFlag)}
                />
            </PayPalScriptProvider>
        );
    }, [regAllowed, spectatorFlag]);

    try {
        return (
            <>
                <Card maxWidth="1400px" padding={5} mt={4} mb={2}>
                    <Flex flexWrap="wrap" direction="row" justifyContent="space-evenly">
                        <Box alignContent="space-around">
                            <Heading align="center" size="md" mb={4}>
                                There are
                            </Heading>
                            <Heading align="center" size="xl" mb={4}>{regRemaining}</Heading>
                            <Heading align="center" size="md" mb={4}>
                                registration slots left.
                            </Heading>
                        </Box>
                        <Box maxWidth={{base: "300px", xl: "775px"}}>
                        <Text mb={4}>
                            Space is limited at this event, so please register as soon as possible.  You can register as either a
                            spectator or a competitor.
                        </Text>
                        <Text mb={4}>
                            If you register as a spectator, you can access the event space and play on any machines at any point 
                            during the hours of the event, as long as no one has a set scheduled at that time.  The cost is <strong>${eventConfig["spectatorPrice"]}.00</strong>.
                        </Text>
                        <Text mb={4}>
                            Registering as a competitor will allow you to schedule at least one time slot on the schedule, with
                            an additional time slot being available for competitors with over <strong>{eventConfig["doubleSlotCutoff"]} TP+LP</strong> in <Link color='teal.300' href={`http://${eventConfig["eventShort"]}.groovestats.com/`} isExternal>Stamina RPG {eventConfig["srpgNum"]} <Icon as={FiExternalLink} mx='2px' top='3px' position="relative"/></Link>.
                            To register to compete, the cost is <strong>${eventConfig["competitorPrice"]}.00</strong>, with the extra money going towards the prize pot.
                        </Text>                     
                        <Divider mt={4} mb={4} orientation='horizontal'/>
                        <Stack spacing={[1, 5]} direction={['column', 'row']}>
                            <Checkbox isDisabled={requestActive || willCompete} size="lg" isChecked={willSpectate} onChange={()=>willSpectateChecked()}>Register as Spectator</Checkbox>
                            <Checkbox isDisabled={requestActive || willSpectate} size="lg" isChecked={willCompete} onChange={()=>moddingPadChecked()}>Register as Competitor</Checkbox>
                        </Stack>                           
                        </Box>
                    </Flex>                                             
                </Card>
                <Collapse in={showPaypal} animateOpacity unmountOnExit>
                    <Card maxWidth="1400px" padding={5} mt={4} mb={2}>
                        <Heading align="center" size="xl" mb={4}>${badgeCost}.00 to register</Heading>
                        <Flex mb={4} flexDirection="column" flexFlow="wrap" gap={3} alignItems="center" justifyContent="space-evenly">
                            <Box flex="1 100%" maxWidth={{base: "300px", xl: "650px"}} padding={4} ml="auto" mr="auto" borderRadius={8} bgColor="white">
                                {paypalDisplay}
                            </Box>
                        </Flex>                         
                    </Card>
                </Collapse>
                <div ref={regEndRef} />
            </>
        );
    } catch (e) {
        console.error("RegistrationForm render error: ", e);
    }
}